import { FORM_VALIDATION_ERROR } from '../actions/types';

const initialState = {};

function reducer(state: any = initialState, action: { type: string; payload?: any }) {
  switch (action.type) {
    case FORM_VALIDATION_ERROR:
      return action.payload;
    default:
      return state;
  }
}

export default reducer;
